/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ counted: NonNullable<unknown>, total: NonNullable<unknown> }} Stocktake_Submit_Dialog_LinesInputs */

const vi_stocktake_submit_dialog_lines = /** @type {(inputs: Stocktake_Submit_Dialog_LinesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.counted}/${i?.total} dòng đã kiểm`)
};

/**

* @param {Stocktake_Submit_Dialog_LinesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_dialog_lines = /** @type {((inputs: Stocktake_Submit_Dialog_LinesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_Dialog_LinesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_dialog_lines(inputs)
});